import { handleHideModal } from 'components/global/_helpers/global.helpers';
import SimpleModal from 'components/global/SimpleModal';
import FounderDealForm from 'components/global/FounderDealForm';
import { handleSubmitCreateDeal } from 'components/views/FounderDeals/_helpers/founderDeals.events';
import { $view } from 'signals/global.signals';

const FounderAddDealModal = () => (
  <SimpleModal
    show={$view.value?.activeModal === 'founder-add-deal'}
    title="Add Raise"
    isLoading={$view.value?.isModalLoading}
    onHide={handleHideModal}
    onPrimaryClick={handleSubmitCreateDeal}
    primaryButtonText="Save"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
    size="xl"
  >
    <FounderDealForm />
  </SimpleModal>
);

export default FounderAddDealModal;
